export default {
  computed: {
    current_organization(){
      return this.state.current_org
    },
    registration() {
      return this.state.current_reg
    },
    editing_as_an_org(){
      //if (this.current_organization.id && !this.state.current_reg.id) return false; // If org is creating a provisioned registration, then all validations must work.
      //^^^ this was a thing, but Nick changed the logic once again. Now even on provisioned registration, org can do whatever they want
      return this.current_organization.id && !this.preview;
    },
    editing_as_a_family(){
      return !this.editing_as_an_org
    },
    program() {
      return this.registration.program
    },
    preview() {
      return this.registration.preview
    },
    creating_provisioned(){
      return this.state.current_org.id && !this.registration.id && !this.registration.preview
    },
    editing_provisioned(){
      return this.state.current_org.id && this.registration.owner_type === 'TempUser'
    },
    enable_autosave(){
      return window.enable_autosave;
    }
  },
  methods: {
    disable_object_if_no_spaces({object, registration}){
      if (!this.current_organization.id && object.no_spaces()) return true; // disable if we are family and there is no spaces on this section
      if (registration.preview && object.no_spaces())          return true; // hack for making preview work as normal family. Disabling sec
      return false
    },
    should_render_section_form({registration, program}){
      if (program.owned_by(this.current_organization)) return true; //always render checkboxes for organization
      if (registration.preview)                        return true; //always render checkboxes for preview

      if (registration.isStillPending() && program.registration_open()) return true; //rendering checkboxes if program is open and reg is not yet completed
      if (registration.allow_edit_sections())                           return true; //if registration is finished. But program allows to edit sections while program is open we render checkboxes
      return false;
    },
  },
}
